import { useCallback, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.js';
import { listRework, requestRework } from '../api/quality.js';
import { ApiError } from '../api/client.js';

export function ReworkPage(): ReactNode {
  const { id = '' } = useParams<{ id: string }>();
  const { token } = useAuth();
  const [rows, setRows] = useState<readonly unknown[]>([]);
  const [instructions, setInstructions] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setRows(await listRework(id, token)); } catch (err) { setError(err instanceof ApiError ? err.message : 'Load failed'); }
  }, [id, token]);
  useEffect(() => { void load(); }, [load]);

  async function submit(): Promise<void> {
    setError(null); setMsg(null); setBusy(true);
    try {
      await requestRework(id, instructions, token);
      setMsg('Rework requested');
      setInstructions('');
      await load();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Save failed');
    } finally { setBusy(false); }
  }

  return (
    <main aria-label="rework">
      <h1>Rework — {id}</h1>
      {error ? <div role="alert">{error}</div> : null}
      {msg ? <div role="status">{msg}</div> : null}
      <div aria-label="rework-count">{rows.length} request(s)</div>
      <form aria-label="rework-form" onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        <label>Correction instructions
          <textarea aria-label="correctionInstructions" value={instructions} onChange={(e) => setInstructions(e.target.value)} required />
        </label>
        <button type="submit" disabled={busy || !instructions}>Request rework</button>
      </form>
    </main>
  );
}
